import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ExtensionsRoutingModule } from 'root/extensions/extensions-routing.module';
import { SharedModule } from 'shared/shared.module';
import { CourierExtensionsComponent } from './courier-extensions/courier-extensions.component';
import { CourierMatchersComponent } from './courier-extensions/matchers/courier-matchers.component';
import { MatcherDialogComponent } from './courier-extensions/matchers/matcher-dialog/matcher-dialog.component';
import { DocumentExtensionsComponent } from './document-extensions/document-extensions.component';
import { SimpleExtensionsComponent } from './simple-extensions/simple-extensions.component';
import { UpdateExtensionProjectsDialogComponent } from './update-extension-projects-dialog/update-extension-projects-dialog.component';

@NgModule({
  declarations: [
    CourierExtensionsComponent,
    DocumentExtensionsComponent,
    UpdateExtensionProjectsDialogComponent,
    CourierMatchersComponent,
    MatcherDialogComponent,
    SimpleExtensionsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    DragDropModule,
    ExtensionsRoutingModule,
  ],
  providers: [],
})
export class ExtensionsModule {
}
